<template>
  <div class="union-cart-entry">
    <div class="union-group-wrapper">
      <div class="union-header">
        <div>
          <div class="union-title" v-html="unionTile"></div>
        </div>
        <div v-if="item.can_check && item.materials_info.length" class="ziliao union-ziliao" style="margin-top: 0;">
          <span style="background:rgba(51,51,51,0.03);border-radius:4px;cursor:pointer;color:rgba(51,51,51,0.6);">
              <i class="fa fa-zeng" style="color:#FFA000;transform: translateY(-2px);vertical-align: initial;"></i>&nbsp;&nbsp;联报赠品*{{ item.materialsCount }}
          </span>
        </div>
      </div>
      <div v-if="item.union_cart_list && item.union_cart_list.length" class="union-list-wrapper">
        <confirmItem v-for="cla in item.union_cart_list" :isGroup="isGroup" :item="cla" :key="cla.class_id" />
      </div>
    </div>
  </div>
</template>

<script>
import confirmItem from './confirmItem'

export default {
  props: {
    isGroup: Boolean,
    item: Object
  },
  computed: {
    unionTile () {
      let discountPrice = ''
      const priceInfo = this.$parent.priceInfo
      const computedPrice = !!priceInfo
      const unionPrice = (priceInfo && priceInfo.unionMap && priceInfo.unionMap[this.item.union_id])
      if (computedPrice && unionPrice) {
        discountPrice = Number(((unionPrice.original_price - unionPrice.real_price) / 100).toFixed(2))
      }
      // if (this.item.can_check && (this.item.union_cart_list.length === this.item.unionSelectLength)) {
      if (this.item.union_id) {
        return `<span class="sprite-lbshen lianbao-tag"></span><span>已减${discountPrice}元</span>`
      } else {
        return ''
      }
    }
  },
  components: { confirmItem }
}
</script>
<style lang="scss">
@import "@/assets/scss/_base.scss";
$primary-color:#333;
// @import "@/assets/scss/partials/_order.scss";
@mixin cartlist() {
  .invalid-course-action {
    margin-top: 50px;
    margin-bottom: 16px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(51, 51, 51, .4);
    line-height: 30px;
  }
  .live-card-table {
    border-radius: 2px;
  }
  .union-cart-entry {
    margin-top: 12px;

    .union-mobile-ziliao {
      margin-top: 0;
      padding: 10px;
      text-align: right;
      position: relative;

      &::before {
        content: '';
        position: absolute;
        height: 1px;
        width: calc(100% - 35px);
        left: 20px;
        top: 0;
        background: rgba(51, 51, 51, 0.1);
      }
    }

    &.cart-entry-selected {
      background: unset;

      .union-header, .union-mobile-ziliao {
        background: rgba(0, 199, 191, 0.04);
      }
    }

    & + .cart-entry {
      margin-top: 12px;
    }

    & + .union-cart-entry {
      margin-top: 12px;
    }
  }
  .ziliao {
    margin-top: 29px;
    @media screen and (max-width: 767px) {
      margin-top: 4px;
      margin-left: -4px;
    }

    .fa-zeng {
      vertical-align: text-top;
    }

    span {
      background: rgba(51, 51, 51, 0.03);
      border-radius: 4px;
      cursor: pointer;
      color: rgba(51, 51, 51, 0.6);
      display: inline-block;
      height: 22px;
      line-height: 22px;
      padding: 0 4px;
    }
  }
  .union-group-wrapper {
    border-radius: 2px;
    border: 1px solid rgba(51, 51, 51, 0.1);

    .union-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-left: 17px;
      padding-right: 32px;
      height: 48px;
      color: rgba(51, 51, 51, 1);
      border-bottom: 1px solid rgba(51, 51, 51, 0.1);
      @media screen and (max-width: 767px) {
        padding-left: 8px;
      }

      .union-title {
        display: inline-block;
        cursor: pointer;
        transform: translateY(1px);
        color: rgba(51, 51, 51, 0.6);
        @media screen and (max-width: 767px) {
          font-size: 12px;
        }

        span {
          color: rgba(255, 160, 0, 1);
        }

        .fa-chevron-right {
          transform: translateY(-1px);
        }
      }
    }

    .cart-entry {
      border: 0;
      position: relative;
      @media screen and (max-width: 767px) {
        .table-cell.col-1 {
          left: 10px;
        }
      }

      & + .cart-entry {
        border-top: 0;
        margin-top: 0;

        &::before {
          content: '';
          position: absolute;
          width: calc(100% - 110px);
          height: 1px;
          left: 80px;
          top: 0;
          background: rgba(51, 51, 51, 0.1);
          @media screen and (max-width: 992px) {
            width: calc(100% - 75px);
            left: 40px;
          }
          @media screen and (max-width: 767px) {
            width: calc(100% - 35px);
            left: 20px;
          }
        }
      }
    }
  }
  .cart-entry {
    font-size: 14px;

    font-weight: 400;
    color: $primary-color;
    display: table;
    padding: 32px;
    padding-left: 0;
    width: 100%;
    border: 1px solid rgba(51, 51, 51, 0.1);
    box-sizing: border-box;
    > div {
      box-sizing: border-box;
    }

    @media screen and (max-width: 767px) {
      padding-top: 16px;
      padding-bottom: 8px;
      .cart-price-box {
        text-align: right;
      }
    }

    &-selected {
      background: rgba(0, 199, 191, 0.04);
    }

    &.invalid {
      position: relative;
      background: rgba(51, 51, 51, 0.04);

      &::after {
        position: absolute;
        content: " ";
        width: 100%;
        left: 0;
        z-index: 1;
        top: 0;
        height: 100%;
        background: rgba(255, 255, 255, .7);
      }
    }

    & + .cart-entry {
      border-top: 1px solid rgba(51, 51, 51, 0.1);
      margin-top: 12px;
    }

    .strong {
      font-size: 16px;
      font-family: SFProDisplay-Medium, SFProDisplay;
      font-weight: 500;
    }

    .teacher {
      color: rgba(51, 51, 51, .8);
    }

    .chapters {
      color: rgba(51, 51, 51, 0.5);
      font-size: 12px;
      line-height: 14px;
      position: relative;
      top: -1px;
    }

    .table-cell {
      position: relative;
      vertical-align: top;
      display: table-cell;

      img {
        border-radius: 4px;
      }

      a {
        color: #333;
      }

      a {
        @media screen and (min-width: 768px) {
          width: 95%;
          display: inline-block;
          max-width: 337px;
        }
      }

      &.col-2 {
        width: 170px;
        max-height: 96px;
      }

      &.col-3 {
        width: 337px;
      }

      &.col-4 {
        width: 204px;
      }

      &.col-5 {
        // width: 134px;
      }

      @media screen and (max-width: 767px) {
        line-height: 1.8;
        &.col-1 {
          position: absolute;
          // top: 50%;
          left: 20px;
          width: auto;
        }
        display: block;
        &.col-2,
        &.col-3,
        &.col-4,
        &.col-5,
        &.col-6 {
          width: 100%;
        }
      }
    }

    .zhixin-checkbox-wrapper {
      display: inline-block;
      width: 20px;
    }

    .zhixin-checkbox-wrapper .check {
      width: 18px;
      height: 18px;
    }

    .select-button {
      width: 82px;
      text-align: center;
      vertical-align: middle;
    }

    .delete {
      cursor: pointer;
    }
  }

  .active-price {
    color: $brand-warning;
  }
  .group-price {
    color: $group-color;
  }
  .delete-price {
    color: rgba(51, 51, 51, 0.3);
    display: inline-block;
    border-bottom: 1px solid;
    height: 11px;
  }
  .fixed-bar {
    bottom: 0;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px -4px 8px 0px rgba(139, 152, 169, 0.08);

    .zhixin-checkbox-wrapper {
      margin-top: 20px;
      @media screen and (max-width: 767px) {
        margin-top: 15px;
      }
    }
  }
  .quzhifu {
    width: 171px;
    height: 72px;
    border-radius: 0;
    font-size: 18px;
    font-weight: bold;
    background: linear-gradient(308deg, rgba(56, 211, 205, 1) 0%, rgba(0, 199, 191, 1) 100%);
    @media screen and (max-width: 767px) {
      height: 60px;
      width: auto;
    }
  }
  .total-cost {
    display: inline-block;
    vertical-align: middle;
    margin-right: 10px;
  }
  .union-tag {
    border-radius: unset;
    font-weight: 500;
    color: rgba(255, 160, 0, 1);
    line-height: 16px;
    min-width: 68px;
    height: 23px;
    background: rgba(255, 160, 0, 0.1);
    vertical-align: middle;
    position: relative;
  }
  .union-price-tag {
    border-radius: 2px;
    font-weight: 500;
    color: rgba(255, 160, 0, 1);
    line-height: 16px;
    height: 23px;
    background: rgba(255, 160, 0, 0.1);
    vertical-align: middle;
    position: relative;

    &::after {
      content: '';
      position: absolute;
      right: 13px;
      top: -12px;
      border: 6px solid transparent;
      border-bottom-color: rgba(255, 160, 0, 0.1);
    }
  }
  .union-tag-right {
    top: -4px;

    &::after {
      content: '';
      position: absolute;
      right: -12px;
      top: 5px;
      border: 6px solid transparent;
      border-left-color: rgba(255, 160, 0, 0.1);
    }

    @media screen and (max-width: 767px) {
      &::after {
        right: 13px;
        bottom: -12px;
        border-top-color: rgba(255, 160, 0, 0.1);
      }
      right: 13px;
      bottom: -12px;
      border-top-color: rgba(255, 160, 0, 0.1);
      display: block;
      transform: translate(10px, 10px);
    }
  }
  .empty-state p {
    margin-bottom: 22.8px;
  }
  .label-select-all {
    line-height: 30px;
    font-size: 18px;

    font-weight: 400;
    padding-left: 32px;
    color: rgba(51, 51, 51, 1);
  }
}
#union-view{
  @include cartlist();
}
</style>
